module.exports = __webpack_public_path__ + "static/media/board.d15c1446.png";